import request from '@/config/axios'

/**
 * 景区会员模式（平台端 platform / 自营端 self）
 * 关联移动端 /scenic/member-mode 接口，控制 C 端会员景区首页/列表模式
 */
export const getScenicMemberModeList = (memberIds: number[]) =>
  request.get({ url: '/scenic/member-mode/list', params: { memberIds: memberIds.join(',') } })

export const setScenicMemberMode = (memberId: number, mode: 'platform' | 'self') =>
  request.put({ url: '/scenic/member-mode', data: { memberId, mode } })
